<template>
    <v-card class="detail-card">
      <v-card-title>
        <h3>{{title}}</h3>
      </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="detailHeadersTotals"
        :items="onlyTopsItems"
        no-data-text=""
        hide-actions
        class="elevation-1 nodata"
        :pagination.sync="pagination2"
      >
      <template v-slot:items="">
      </template>
      <template slot="footer">
        <tr>
          <td><strong >Totales</strong></td>
          <td class="text-xs-right">{{ totals.tops  | currency('') }}</td>
          <td class="text-xs-right">{{ totals.pieces_per_kilo | currency('') }}</td>
          <td class="text-xs-right">{{ totals.tops_price | currency('') }}</td>
          <td v-if="showRoute">&nbsp;</td>
          <td v-if="showOperations">&nbsp;</td>
        </tr>
      </template>
      </v-data-table>

      <v-data-table
        :headers="computedHeaders"
        :items="onlyTopsItems"
        hide-actions
        class="elevation-1"
        item-key="id"
        no-data-text="No hay información que mostrar"
        :pagination.sync="pagination"
      >
      <template v-slot:items="props">
          <td class="text-xs-left">Tops y Piezas por Kilo</td>
          <td  v-if="showOperations" ><v-icon color="red" @click="deleteItem(props.item)">delete_forever</v-icon></td>
          <td class="text-xs-right" >{{ props.item.tops | currency('') }}</td>
          <td class="text-xs-right" >{{ props.item.pieces_per_kilo | currency('') }}</td>
          <td class="text-xs-right" >{{ props.item.tops_price | currency('') }}</td>
          <td class="text-xs-left" v-if="showRoute">
            <router-link :to="routeLink(props.item)">{{ props.item.route_description }}</router-link>
          </td>
      </template>
      <template slot="footer">
        <tr>
          <td><strong >Totales</strong></td>
          <td class="text-xs-right">{{ totals.tops  | currency('') }}</td>
          <td class="text-xs-right">{{ totals.pieces_per_kilo | currency('') }}</td>
          <td class="text-xs-right">{{ totals.tops_price | currency('') }}</td>
          <td v-if="showRoute">&nbsp;</td>
          <td v-if="showOperations">&nbsp;</td>
        </tr>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { PUOND_CONVERT } from '../../utils/constants';
import _ from 'lodash';
export default {
  props: {
    items: Array,
    title: String,
    showRoute: {
      type: Boolean,
      default: false,
    },
    showOperations: {
      type: Boolean,
      default: true,
    },
    currentBag: {
      type: Object,
    },
  },
  data() {
    return {
      detailHeaders: [
        { align: 'right', text: '', sortable: false, width: '1%' },
        { align: 'right', text: '', width: '1%', sortable: false, isOperation: true },
        { align: 'right', text: 'Tops', value: 'tops', width: '1%'},
        { align: 'right', text: 'Piezas Kilo', value: 'pieces_per_kilo', width: '1%' },
        { align: 'right', text: 'Precio', value: 'tops_price', width: '1%' },
        { align: 'right', text: 'Ruta', value: 'route_description'},
      ],
      detailHeadersTotals: [
        { align: 'right', text: '', width: '1%', sortable: false, isOperation: true },
        { align: 'right', text: 'Tops', value: 'tops', width: '1%'},
        { align: 'right', text: 'Piezas Kilo', value: 'pieces_per_kilo', width: '1%' },
        { align: 'right', text: 'Precio', value: 'tops_price', width: '1%' }
      ],
      pagination: {
        sortBy: 'id',
        descending: false,
        rowsPerPage: -1,
      },
      pagination2: {
        sortBy: 'id',
        descending: false,
        rowsPerPage: -1,
      },
    };
  },
  methods: {
    deleteItem(event) {
      this.$emit('deleteItem', event);
    },
    routeLink(row) {
      return `/bag/${this.currentBag.id}/route/${row.route_id}`;
    },
  },
  computed: {
    totals() {
      const initialValues = {
          tops: 0,
          pieces_per_kilo: 0,
          tops_price: 0,
      };
      if (!this.items || this.items.length === 0) {
        return initialValues;
      } else {
        const results = Object.assign({}, initialValues);
        for (const line of this.items.filter((e) => e.type === 'TOP')) {
          results.tops += parseFloat(line.tops, 10);
          results.pieces_per_kilo += parseFloat(line.pieces_per_kilo, 10);
          results.tops_price += parseFloat(line.tops_price);
        }
        return results;
      }
    },
    computedHeaders() {
      let results = this.detailHeaders;
      if (!this.showRoute) {
        results = results.filter((e) => {
          return e.text !== 'Ruta';
        });
      }
      if (!this.showOperations) {
        results = results.filter((e) => {
          return !e.isOperation;
        });
      }
      return results;
    },
    onlyTopsItems() {
      return this.items.filter((e) => e.type === 'TOP');
    },
  },
};
</script>

<style >
.col-header {
  background-color: rgba(0, 0, 0, .05); 
  padding-bottom: 10px; 
  padding-top: 10px
}

.nodata .text-xs-center {
  display: none;
}
</style>